import { PATH_APP } from './paths';
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthProtect from 'src/components/Auth/AuthProtect';
import AppLayout from 'src/layout';
// import DashboardLayout from 'src/layouts/DashboardLayout';

// ----------------------------------------------------------------------

const AppRoutes = {
  path: PATH_APP.root,
  layout: AppLayout,
  guard: AuthProtect,
  // excludePaths: [PATH_APP.general.talentCardById],
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      exact: true,
      path: PATH_APP.general.talentCard,
      component: lazy(() => import('src/views/TalentCardView'))
    },
    {
      exact: true,
      path: PATH_APP.general.onboarding,
      component: lazy(() => import('src/views/onboarding/ResumeUpload'))
    },
    {
      exact: true,
      path: PATH_APP.general.getcurated,
      component: lazy(() =>
        import('src/views/OpportunitiesView/GetCurated/GetCurated')
      )
    },
    {
      exact: true,
      path: PATH_APP.general.aiInterview,
      component: lazy(() =>
        import('src/views/OpportunitiesView/GetCurated/AIInterview')
      )
    },

    {
      exact: true,
      path: PATH_APP.general.talentCardNew,
      component: () => <Redirect to={PATH_APP.general.talentCard} />
    },

    {
      exact: true,
      path: PATH_APP.general.communities,
      component: lazy(() => import('src/views/Communities/Communities'))
    },
    {
      exact: true,
      path: PATH_APP.general.communities2,
      component: lazy(() => import('src/views/Communities/Communities2'))
    },
    {
      exact: true,
      path: PATH_APP.general.communities3,
      component: lazy(() => import('src/views/Communities/Communities3'))
    },
    {
      exact: true,
      path: PATH_APP.general.opportunities,
      component: lazy(() => import('src/views/OpportunitiesTabs/JobTabs'))
    },

    {
      exact: true,
      path: PATH_APP.general.opportunities2,
      component: lazy(() =>
        import('src/views/OpportunitiesView/ViewApplication/OpportunityListNew')
      )
    },
    {
      exact: true,
      path: PATH_APP.general.opportunitiesDetail,
      guard: null,
      component: lazy(() =>
        import('src/views/OpportunitiesView/OpportunityCard')
      )
    },
    {
      exact: true,
      path: PATH_APP.general.opportunitiesTabs,
      guard: null,
      component: lazy(() => import('src/views/OpportunitiesTabs/JobTabs'))
    },
    {
      exact: true,
      path: PATH_APP.general.inbox,
      component: lazy(() => import('src/views/InboxView'))
    },

    // ----------------------------------------------------------------------
    {
      component: () => <Redirect to="/404" />
    }
  ]
};

export default AppRoutes;
